
exports.setupCalendar = (rootElement, previousPrizes, currentPrize) => {

  // hide all previous tiles and render previous prizes
  previousPrizes.forEach(prize => {

    const tileElements = rootElement.querySelectorAll(`[data-advent-tile="${prize.day}"]`);

    Array.from(tileElements)
      .forEach(tile => {
        tile.style.display = 'none';
      });

    const prizeImageElements = rootElement.querySelectorAll(`[data-advent-prize="${prize.day}"]`);

    Array.from(prizeImageElements)
      .forEach(prizeElement => {
        prizeElement.src = prize.imageUrl;
        prizeElement.parentNode.style.opacity = '1';
      });

  });

  // render current day prize
  const currentPrizeImages = rootElement.querySelectorAll(`[data-advent-prize="${currentPrize.day}"]`);

  Array.from(currentPrizeImages)
    .forEach(prizeElement => {
      prizeElement.src = currentPrize.imageUrl;
    });

};

exports.renderTileOptions = (rootElement, tiles) => {

  tiles.forEach(tile => {

    const tileElements = rootElement.querySelectorAll(`[data-advent-tile="${tile.dayNumber}"]`);

    Array.from(tileElements)
      .forEach(el => {

        const x = module.exports.readTileNumberFont(el);
        console.log(x);
        module.exports.setupTileNumberPosition(el, tile.position);
        module.exports.setupTileNumberFont(el, tile);
        module.exports.setupTileCover(el, tile);

        const y = module.exports.readTileNumberFont(el);
        console.log(y);

      });

  });

};

/** TILE COVER */
exports.setupTileCover = (tileElement, tileConfig) => {

  const { coverType, coverColor, coverImg } = tileConfig;

  if (coverType === 'image') {

    if (!coverImg)
      console.warn('tile coverImg not set');

    tileElement.style.backgroundColor = 'unset';
    tileElement.style.background = `url("${tileConfig.coverImg}")`;

  }

  if (coverType === 'color') {

    if (!coverColor)
      console.warn('tile coverColor not set');

    tileElement.style.background = 'unset';
    tileElement.style.backgroundColor = coverColor;
  }

};

exports.readTileCover = tileElement => {

  const styles = window.getComputedStyle(tileElement);

  const coverColor = styles.backgroundColor;
  let coverImg = styles.backgroundImage;
  if (coverImg !== 'none')
    coverImg = coverImg.slice(5, -2); // slice the url(" and ") part

  const coverType = (coverImg === 'none') ? 'color' : 'image';

  return { coverColor, coverImg, coverType };

};

/** TILE NUMBER FONT */
exports.setupTileNumberFont = (tileElement, tileConfig) => {

  const { fontFamily, fontSize, fontColor } = tileConfig;

  const tileNumber = tileElement.querySelector('[data-advent-number]');

  tileNumber.style.setProperty('font-family', fontFamily, 'important');
  tileNumber.style.setProperty('font-size', fontSize + 'px', 'important');
  tileNumber.style.setProperty('color', fontColor, 'important');

};

exports.readTileNumberFont = tileElement => {

  const tileNumber = tileElement.querySelector('[data-advent-number]');

  const styles = window.getComputedStyle(tileNumber);

  const fontFamily = styles.fontFamily;
  const fontSize = styles.fontSize;
  const fontColor = styles.color;

  return {
    fontFamily,
    fontSize,
    fontColor
  };
};

/** TILE NUMBER POSITION */
exports.setupTileNumberPosition = (tileElement, number) => {
  const tileNumber = tileElement.querySelector('[data-advent-number]');
  const tileInner = tileNumber.parentElement;
  let positionClassname = null;

  Array.from(tileInner.classList).forEach(classname => {
    if (classname.startsWith('num-pos-')) {
      positionClassname = classname;
    }
  });

  tileInner.classList.remove(positionClassname);
  tileInner.classList.add('num-pos-' + number);

};

exports.readTileNumberPosition = tileElement => {

  const tileNumber = tileElement.querySelector('[data-advent-number]');
  const tileInner = tileNumber.parentElement;

  let positionClassname = null;

  Array.from(tileInner.classList).forEach(classname => {
    if (classname.startsWith('num-pos-')) {
      positionClassname = classname;
    }
  });

  // if not set return position number 1
  if (positionClassname === null)
    return 1;

  // last character is position number
  return positionClassname.slice(-1);

};